export const enTranslations = {
	'CUSTOMER_PORTAL': 'Customer portal of',
	'PARTNER_PORTAL': 'Partner portal of',
	'HELLO': 'Welcome to SarvCRM portal',
	'UPLOAD_FILE': 'Click to upload',
	'FILE_TYPE': 'File type',
	'PLEASE_WAIT': 'Please wait ...',
	'LIST_VIEW': "List",
	'DETAIL_VIEW': "Detail",
	'EDIT': "Edit",
	'SAVE': "Save",
	'SAVE_AND_CONTINUE' : "Save and continue",
	'CANCEL': "Cancel",
	'CONFIG': "Setting",
	'PRIMARY': "Primary",
	'MOBILE': "Mobile",
	'DRAG_HERE': 'Drag and drop to upload',
	'NEXT_STEP': 'Next step',
	'PREV_STEP': 'Previous step',
	'OR': 'or',
	'BROWSE_FILE': 'Browse file',
	'ATTACHMENT': 'Attachment',
	'USER_INFORMATION': 'User information',
	'COMMENTS': 'Comments',
	'SUBMIT_COMMENT': 'Submit comment',
	'PDF': 'Print PDF',
	'RAHKARAN_REPORTS': 'Rahkaran reports',
	'PAY': 'pay',
	'UNREAD_NOTIFICATIONS': 'Unread notification',
	'APPROVE': 'Approve',
	'DECLINE': 'Decline',
	'GATEWAY' : {
		'LBL_PAY_INFORMATION' : 'payment details',
		'LBL_ACCOUNT' : 'Account',
		'LBL_AMOUNT_PAYABLE' : 'Price',
		'LBL_CURRENCY_RIAL' : 'Rial',
		'LBL_SELECT_GATEWAY' : 'Choose payment gateway',
		'LBL_SAMAN_GATEWAY' : 'samankish gateway',
		'LBL_GATEWAY_DESCRIPTION': 'pay with',
		'LBL_TRANSFER_TO_GATEWAY' : 'Transfer to gateway',
		'LBL_ALREADY_PAID': 'Already paid' ,
		'LBL_NOT_PAID': 'Not paid',
		'LBL_SUCCESS_PAYMENT_STATUS': 'Payment was successful.',
		'LBL_FAILED_PAYMENT_STATUS': 'An error occurred during your payment.',
		'LBL_SUCCESS': 'Success.',
		'LBL_RETURN_TO_BACK' : 'Return',
	},
	'NO_DATA': 'There\' is not any data',
	'PENDING': 'Pending',
	'APPROVED': 'Approved',
	'REJECTED': 'Rejected',
	'APPROVAL_STATUS': 'َApproval status',
	'NO_DASHLET': 'There is not any dashlet.',
	'READ_ALL_NOTIFICATIONS': 'Read all notifications',
	'SEE_MORE' : 'See more...',
	'FAQ': 'FAQ',
	'TOTAL_RESULT': 'Total result',
	'FIELD' : 'Field',
	'VALUE' : 'Value',
	'OPERATOR' : 'Operator',
	'DOWNLOAD' : 'Download',
	'PROFILE': {
		'SECURITY_SETTINGS': 'Security settings',
		'LANGUAGE' : 'Language',
		'THEME' : 'Theme',
		'NAME': 'Name',
		'USERNAME': 'Username',
		'ACCOUNT': 'Account',
		'PHONE': 'Phone number',
		'EMAIL': 'Email address',
		'USER_TYPE': 'User type',
		'PARTNER': 'Partner',
		'CUSTOMER': 'Customer',
		'CURRENT_PASSWORD': 'Current password',
		'NEW_PASSWORD': 'New password',
		'CONFIRM_PASSWORD': 'Confirm password',
		'EQUAL_PASSWORD' : 'Passwords do not match',
	},
	'FIELDS' : {
		'NAME': 'Name',
		'PART_NUMBER': 'Part number',
		'BRAND_NAME': 'Brand',
		'PRODUCT_QTY': 'Quantity',
		'PRODUCT_LIST_PRICE': 'List price',
		'PRODUCT_NAME': 'Product name',
		'QTY': 'Qty',
		'UNIT_PRICE': 'Unit price',
		'DISCOUNT': 'Discount',
		'TAX': 'Tax',
		'TOTAL_PRICE': 'Total price',
		'GRAND_TOTAL': 'Grand total',
		'TOTAL_QTY': 'Total quantity',
		'TITLE' : 'Title',
		'ASSIGNED_USER_NAME' : 'Assigned user name',
		'END_DATE' : 'End date',
		'STATUS' : 'Status',
		'TYPE' : 'Type',
		'DESCRIPTION' : 'Description',
		'ITEM_DESCRIPTION' : 'Description',
		'DATE_START' : 'Date start',
		'DATE_END' : 'Date end',
		'PRIMARY_NUMBER_RAW' : 'Primary number raw',
		'BILLING_ADDRESS_STATE' : 'State',
		'BILLING_ADDRESS_CITY' : 'City',
		'BILLING_ADDRESS_STREET' : 'Address',
		'SALES_STAGE' : 'Sales stage',
		'DATE_CLOSED' : 'Date closed',
		'AMOUNT' : 'Amount',
		'SALUTATION' : 'Salutation',
		'FIRST_NAME' : 'First name',
		'LAST_NAME' : 'Last name',
		'NATIONAL_CODE' : 'National code',
		'LEAD_SOURCE' : 'Lead source',
		'QUOTE_DATE' : 'Quote date',
		'NUMBER' : 'Number',
		'TOTAL_AMOUNT' : 'Total amount',
		'INVOICE_DATE' : 'Invoice date',
		'CASE_NUMBER' : 'Case number',
		'PURCHASE_ORDER_DATE' : 'Purchase order date',
		'GEOGRAPHICAL': 'Geographical area',
		'COUNTRY': 'Country',
		'STATE': 'State',
		'CITY': 'City',
		'POSTAL_CODE': 'Postal code',
		'LOCATION': 'Location',
		'ADDRESS': 'Address',
		'BILLING': 'Billing address',
		'SHIPPING': 'Shipping address',
		'DISCOUNT_AMOUNT': 'Discount amount',
		'VAT_AMT': 'Vat amount',
		'PRODUCT_SECOND_QTY': 'Product second quantity',
		'DATE_MODIFIED': 'Date modified',
	},
	'THEMES': {
		'DEFAULT': "Default",
		'SG': "Sarveno",
		'DARK': "Dark",
	},
	'LANGUAGES': {
		'FA': "Persian",
		'EN': "English",
	},
	'FILTER': {
		'DESC': "Descending",
		'ASC': "Ascending",
		'SORT': "Sort",
		'SORT_BY': "Sort by",
		'COUNT': "Count",
		'SEARCH': "Search",
		'RESET': "Reset",
		'DATE_ENTERED' : "Date Entered",
		'FROM_DATE': 'From ...',
		'TO_DATE': 'To ...',
		'ADVANCED_SEARCH' : "Advanced filters",
		'NEW_FILTER': 'Add new filter',
		'FILTER_CLEANER': 'Clear filters',
		'SUBMIT_FILTER': 'Submit',
		'SAVE_FILTERS': 'Save filters',
	},
	'OPERATORS' : {
		'EQUAL': "Equal",
		'NOT_EQUAL': "Not equal",
		'LIKE': "Like",
		'IN': "One of",
		'NOT_IN': "Not one of",
		'GREATER': "Greater than",
		'GREATER_EQUAL': "Greater or equal",
		'LESS': "Less than",
		'LESS_EQUAL': "Less or equal",
		'AFTER': "After",
		'AFTER_EQUAL': "After or equal",
		'BEFORE': "Before",
		'BEFORE_EQUAL': "Before or equal",
		'DATE_RANGE' : "Date range",
	},
	'DATE' : {
		'DAY' : "Today",
		'WEEK' : "7 days ago",
		'MONTH' : "30 days ago", 
		'QUARTER' : "90 days ago", 
		'YEAR' : "365 days ago"
	},
	'ERROR': {
		'PAGE_NOT_FOUND': "Page not found!",
		'ALREADY_ON_PAGE': 'You already on the target page',
		'WRONG_EMAIL_ERROR': 'The email address is not entered correctly!',
		'WRONG_PHONE_NUMBER_ERROR': 'The contact number is not entered correctly!',
		'EMPTY_PHONE_NUMBER_OR_EMAIL_ERROR': 'Please enter your phone number or email address.',
		'WRONG_DATA': 'Please enter your information correctly.',
		'WRONG_CONFIRM_CODE': "The verification code entered is incorrect",
		'PASSWORD_AND_REPEATED_PASSWORD_MISMATCHED': "The password entered and repeated are not the same",
		'WRONG_NATIONAL_CODE': "The national code is not correct",
		'WRONG_POSTAL_CODE': "The postal code is not correct",
		'IS_NUMERIC': "Must be of type number",
		'IS_REQUIRED': "Is required",
		'WRONG_LENGTH': "The length of the data does not meet the required criteria.",
		'NOTHING_TO_SHOW': "There is no information to display",
		'DUPLICATE_BILLING_ADDRESS': "Billing address already exists.",
		'DUPLICATE_SHIPPING_ADDRESS': "Shipping address already exists.",
		'NON_ACCESSIBLE': "There is not access for this action.",
		'DELETE_ALL_LINEITEMS': "Are you sure you want to delete all line items?",
		'SELECT_A_FIELD': "Please select a field.",
		'INVALID_FILE_FORMAT': "Invalid file format.",
	},
	'COMPONENTS': {
		'ADD_PRODUCT': "Add a new product",
		'OPEN_MODAL': "Open modal",
		'DECLINE': "Decline",
		'SAVE': "Save",
		'SELECT_OPTION_PLACEHOLDER': "...",
	},
	'NOTIFICATION' : {
		'COMMENT' : "New Comment",
		'STATUS_CHANGED' : "Modify record",
		'ASSIGNED_TO' : "Assigned to",
		'NEW_INSERT': "New record",
		'APPROVAL': "Approval",
	},
	'AUTHENTICATION': {
		'LOGIN_TO_ACCOUNT': "Login to account",
		'REGISTER_ACCOUNT': "Create account",
		'FORGOT_PASSWORD': "Forgot password?",
		'REMEMBER_ME': "Remember me!",
		'CELL_PHONE': "Cell phone",
		'PASSWORD': "Password",
		'LOGIN': "Login",
		'SIGN_UP': "Register",
		'FIRST_NAME': "First name",
		'LAST_NAME': "Last name",
		'NATIONAL_CODE' : 'National Code',
		'EMAIL': "Email",
		'CONFIRM_CODE': "Verification code",
		'CONFIRM': "Confirm",
		'RETURN': "Return",
		'INSERT_CONFIRM_CODE': "Enter the verification code that was sent to you",
		'FORGOT_PASSWORD_TITLE': "Password recovery",
		'INSERT_USERNAME': "Enter your username",
		'USERNAME': "Username",
		'SEND_CONFIRM_CODE': "Send verification code",
		'INSERT_NEW_PASSWORD': "Enter the new password",
		'NEW_PASSWORD': "New Password",
		'NEW_PASSWORD_REPEAT': "Repeat the new password",
		'SAVE': "Save",
		'TENANT_NAME': 'Subscription name',
		'CHANGE_TENANT': 'Change subscription name',
		'NEXT_STEP': 'Next Step',
	},
	'MENU': {
		'REGISTER': 'Register',
		'REGISTER_CONFIRM': 'Registration confirmation',
		'LOGIN': 'Login',
		'DASHBOARD': 'Dashboard',
		'DYNAMIC': 'Dynamic pages',
		'LIST': 'List',
		'NEW_RECORD': 'New Record',
		'LISTVIEW': "List",
		'DETAILVIEW': "Detail",
		'EDIT_VIEW': 'Sample edit page',
		'FEATURES': 'Features and elements',
		'USER_SETTINGS': 'User settings',
		
		'ACCOUNTS': 'Accounts',
		'ACCOUNT_LIST': 'Account list',
		'ACCOUNT_NEW': 'New account',
		'ACCOUNT_EXIST': 'Current account',

		'ASSETS': 'Assets',
		'ASSET_LIST': 'Asset list',
		'ASSET_NEW': 'New assets',
		'ASSET_EXIST': 'Current assets',

		'CASES': 'Ticket',
		'CASE_LIST': 'Ticket list',
		'CASE_NEW': 'New ticket',
		'CASE_EXIST': 'Current ticket',

		'CLAIMS': 'Claim',
		'CLAIM_LIST': 'Claim List',
		'CLAIM_NEW': 'New claim',
		'CLAIM_EXIST': 'Current claim',

		'CONTACTS': 'Contacts',
		'CONTACT_LIST': 'Contact lists',
		'CONTACT_NEW': 'New contact',
		'CONTACT_EXIST': 'Current contact',

		'CONTRACTS': 'Contracts',
		'CONTRACT_LIST': 'Contract list',
		'CONTRACT_NEW': 'New contract',
		'CONTRACT_EXIST': 'Current contract',

		'CUSTOMER_CONSOLE': 'Customer console',

		'DEPOSITS': 'Deposit',
		'DEPOSIT_LIST': 'Deposit list',
		'DEPOSIT_NEW': 'New deposit',
		'DEPOSIT_EXIST': 'Current deposit',

		'INVOICES': 'Invoice',
		'INVOICE_LIST': 'Invoice list',
		'INVOICE_NEW': 'New Invoice',
		'INVOICE_EXIST': 'Current invoice',

		'LEADS': 'Leads',
		'LEAD_LIST': 'Lead list',
		'LEAD_NEW': 'New lead',
		'LEAD_EXIST': 'Current lead',

		'OPPORTUNITIES': 'Opportunities',
		'OPPORTUNITY_LIST': 'Opportunity list',
		'OPPORTUNITY_NEW': 'New opportunity',
		'OPPORTUNITY_EXIST': 'Current opportunity',

		'PAYMENTS': 'Payments',
		'PAYMENT_LIST': 'Payment list',
		'PAYMENT_NEW': 'New payment',
		'PAYMENT_EXIST': 'Current payment',

		'ORDERS': 'Orders',
		'ORDER_LIST': 'Order list',
		'ORDER_NEW': 'New order',
		'ORDER_EXIST': 'Current order',

		'WORK_ORDERS': 'Work order',
		'WORK_ORDER_LIST': 'Work order list',
		'WORK_ORDER_NEW': 'New Work order',
		'WORK_ORDER_EXIST': 'Current Work order',
		'LOG_OUT': 'Logout',
	},
	'CASES': {
		'LBL_CASE_SELECT': 'select',
		'LBL_CASE_FILE': 'file',
		'LBL_CASE_SWITCH': 'switch',
		'LBL_CASE_CHECKBOX': 'checkbox',
		'LBL_CASE_CHECKBOX_LABEL': 'checkbox label',
		'LBL_CASE_CHECKBOX_LABEL_SWITCH': 'checkbox label switch',
		'LBL_CASE_RADIO': 'radio',
		'LBL_CASE_TEXTAREA': 'textarea',
		'LBL_CASE_DATE': 'date',
		'LBL_CASE_TEXT': 'text',

	},
	'DASHBOARD': {
		'NEW_ANSWERS': 'New answer',
		'SUCCESSFULL_PAYMENTS': 'Successful payment',
		'INPROGRESS_CONTRACTS': 'Contract in progress',
		'UNPAID_INVOICES': 'Unpaid invoice',
		'DETAILS': 'Details',
		'CASE_STATUS': 'tickets status',
		'PAYMENT_STATUS': 'Recent transactions',
		'INVOICE_STATUS': 'Invoices status chart',
	},
	'MODULES': {
		'AOS_QUOTES': 'Quotes',
		'ASSETS': 'Assets',
		'DOCUMENTS' : 'Documents',
		'CALLS' : 'Calls',
		'OPPORTUNITIES' : 'Opportunities',
		'AOS_INVOICES' : 'Invoices',
		'AOS_CONTRACTS' : 'Contracts',
		'PURCHASE_ORDER' : 'Purchase order',
		'LEADS' : 'ُLeads',
		'CONTACTS' : 'Contacts',
		'PAYMENTS' : 'Payments',
		'CASES' : 'Cases',
		'WORK_ORDERS' : 'Work orders',
		'PRODUCT_SAMPLES' : 'Product samples',
		'ACCOUNTS' : 'ََAccounts',
		'KNOWLEDGE_BASE' : 'Articles',
	},
	'Assets': {
		'LBL_ID': 'ID',
		'LBL_ASSET': 'Asset',
		'LBL_NAME': 'Name',
		'LBL_STATUS': 'Status',
		'LBL_SERIAL_NUMBER': 'Serial number',
		'LBL_DATE_MODIFIED': 'Latest update',
	}
};